(function () {
  // Run only when the body has the "locked" marker (from snippets/lock-helpers.liquid)
  var locked = document.body && document.body.classList.contains('locked');
  if (!locked) return;

  // Text shown instead of any price
  var LOCK_TEXT = 'Login to see price';

  // ---- Helpers ----
  function isATCForm(el) {
    if (!el || el.tagName !== 'FORM') return false;
    var action = (el.getAttribute('action') || '').toLowerCase();
    return action.indexOf('/cart/add') !== -1 || el.hasAttribute('data-add-to-cart');
  }

  function isQuickAdd(el) {
    if (!el) return false;
    if (el.matches('[data-quick-add], quick-add, .quick-add')) return true;
    if (el.closest && el.closest('[data-quick-add], quick-add, .quick-add')) return true;
    return false;
  }

  function looksLikePriceNode(el) {
    if (!el) return false;
    var txt = (el.textContent || '').trim();
    // crude but effective guard against money strings
    var moneyish = /[$€£R]\s?\d|(\d[\s,]*\d*\.\d{2})/i.test(txt);
    return moneyish ||
      el.matches('.price, .price-item, [data-price], [data-compare-price], [itemprop="price"], [data-money], .money');
  }

  function nukePrices(root) {
    var nodes = root.querySelectorAll([
      '.price',
      '.price-item',
      '.price__regular',
      '.price__sale',
      '[data-price]',
      '[data-compare-price]',
      '[itemprop="price"]',
      '.money',
      '[data-unit-price]',
      '.unit-price',
      '.price-per-item',
      '.product-badge--price',
      '.product__tax',
      '.price__container',
      '.price--large'
    ].join(','));

    nodes.forEach(function (node) {
      // If the theme has a dedicated lock message spot, keep it; otherwise replace.
      if (!node.querySelector('.locked-msg')) {
        node.innerHTML = '<p class="locked-msg" style="margin:0;">' + LOCK_TEXT + '</p>';
      }
      // Never expose currency via attributes
      node.removeAttribute('content');
      node.removeAttribute('data-money');
      node.removeAttribute('itemprop');
    });

    // Kill stray text-only money bits (defensive)
    Array.prototype.slice.call(root.querySelectorAll('*')).forEach(function (el) {
      if (el.children.length === 0 && looksLikePriceNode(el)) {
        el.textContent = LOCK_TEXT;
      }
    });
  }

  function disableATC(root) {
    // Forms
    root.querySelectorAll('form').forEach(function (f) {
      if (isATCForm(f) || f.closest('quick-add') || f.closest('[data-quick-add]')) {
        f.addEventListener('submit', function (e) { e.preventDefault(); e.stopPropagation(); }, true);
        f.setAttribute('aria-disabled', 'true');
      }
    });

    // Buttons/Links
    root.querySelectorAll('button, a, input[type="submit"]').forEach(function (btn) {
      var name = (btn.getAttribute('name') || '').toLowerCase();
      var type = (btn.getAttribute('type') || '').toLowerCase();
      var id   = (btn.getAttribute('id') || '').toLowerCase();
      var cls  = btn.className || '';

      var isATC =
        type === 'submit' ||
        name.indexOf('add') !== -1 ||
        id.indexOf('add') !== -1 ||
        /\b(add-to-cart|product-form__submit|shopify-payment-button)\b/i.test(cls) ||
        isQuickAdd(btn);

      if (isATC) {
        btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); }, true);
        btn.setAttribute('disabled', 'disabled');
        btn.classList.add('is-disabled');
        // Optional: unify label
        if (!btn.querySelector('.locked-msg')) {
          btn.innerHTML = '<span class="locked-msg">' + LOCK_TEXT + '</span>';
        }
      }
    });

    // Dynamic checkout wrappers
    document.querySelectorAll('.shopify-payment-button, .dynamic-checkout, .product__payment-container')
      .forEach(function (wrap) { wrap.remove(); });
  }

  function scrubJSONLD(root) {
    // Remove "offers" or price-bearing JSON-LD in case an app injects it
    root.querySelectorAll('script[type="application/ld+json"]').forEach(function (script) {
      try {
        var data = JSON.parse(script.textContent);
        var orig = JSON.stringify(data);
        function stripOffers(obj) {
          if (!obj || typeof obj !== 'object') return obj;
          if (Array.isArray(obj)) return obj.map(stripOffers);
          var out = {};
          Object.keys(obj).forEach(function (k) {
            if (k === 'offers' || k === 'price' || k === 'priceCurrency' || k === 'lowPrice' || k === 'highPrice') return;
            out[k] = stripOffers(obj[k]);
          });
          return out;
        }
        var cleaned = stripOffers(data);
        // Only rewrite if something changed
        if (JSON.stringify(cleaned) !== orig) {
          script.textContent = JSON.stringify(cleaned);
        }
      } catch (e) { /* ignore */ }
    });
  }

  function applyAll(root) {
    nukePrices(root);
    disableATC(root);
    scrubJSONLD(root);
  }

  // Initial pass
  applyAll(document);

  // Observe dynamic injections (search, recommendations, app blocks, cart drawer, etc.)
  var mo = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      if (m.addedNodes) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) applyAll(n);
        });
      }
      if (m.type === 'attributes' && m.target) {
        applyAll(m.target);
      }
    });
  });

  mo.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'data-render', 'data-price', 'content']
  });

  // Intercept AJAX cart endpoints
  function blockFetch(input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      url = (url || '').toString().toLowerCase();
      if (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/checkout') !== -1) {
        return Promise.resolve(new Response(JSON.stringify({ ok: false, locked: true }), { status: 403 }));
      }
    } catch (e) {}
    return null;
  }

  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var blocked = blockFetch(input, init);
      if (blocked) return blocked;
      return _fetch.apply(this, arguments);
    };
  }

  if (window.XMLHttpRequest) {
    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      var u = (url || '').toString().toLowerCase();
      if (u.indexOf('/cart/add') !== -1 || u.indexOf('/cart/change') !== -1 || u.indexOf('/checkout') !== -1) {
        // short-circuit by never sending; consumers will see onerror
        this.addEventListener('send', function (e) { e.preventDefault(); }, true);
        this.abort();
        return;
      }
      return _open.apply(this, arguments);
    };
  }
})();
